import { APIDomain } from 'models/API';
import { Storage } from 'repositories/Storage';
import { oauth } from 'repositories/oauth';
import { ApplicationError } from 'models/Error';
import { Result, Success } from 'types';
import { Device } from 'models/Device/type';
import { DeviceDomain } from 'models/Device';

export class OAuthDomain {
  static async loginURL(provider: 'google' | 'github'): Promise<string> {
    const providerRequest = provider === 'google' ? 'google_oauth2' : 'github';
    let url = `${APIDomain.origin()}/auth/${providerRequest}?origin=ios_spa`;

    const uid = await Storage.get('iphone_uid');
    if (uid) {
      url += `&iphone_uid=${uid}`;
    }

    return url;
  }

  static async login(
    onetimeToken: string
  ): Promise<Result<Device | null, ApplicationError>> {
    const uid = await Storage.get('iphone_uid');

    try {
      if (uid) {
        const authorizationToken = await oauth.authorizationToken(onetimeToken);
        await Storage.save('token', authorizationToken);
        return new Success(await DeviceDomain.restore());
      } else {
        const iphoneRegistrationToken = await oauth.iphoneRegistrationToken(
          onetimeToken
        );

        await DeviceDomain.saveIphoneRegistrationToken(iphoneRegistrationToken);
        return new Success({
          iphoneRegistrationToken,
        });
      }
    } catch (e) {
      return ApplicationError.handleForRepositoryError(e);
    }
  }
}
